import { Skeleton } from "../../@/components/ui/skeleton";

export const ScheduleItemSkeleton = () => {
  return (
    <div className="border border-(--neutral-300) p-4 mb-3">
      <Skeleton className="h-5 w-3/4 mb-2" />
      <Skeleton className="h-4 w-1/2" />
    </div>
  );
};